var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._l(_vm.breadcrumbItems, function (item, index) {
    return [item.to && index !== _vm.breadcrumbItems.length - 1 ? _c('b-breadcrumb-item', {
      key: "breadcrumb-".concat(index, "-link"),
      attrs: {
        "to": item.to
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]) : _c('b-breadcrumb-item', {
      key: "breadcrumb-".concat(index, "-active"),
      attrs: {
        "active": true
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")])];
  })], 2), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }